import { dataMember, required, typedArray } from 'santee-dcts';

export class EmailSearchField {
    @dataMember()
    @required()
    public email: string;
}

export class EQueryIdSearchField {
    @dataMember()
    @required()
    public eQueryId: number;
}

export class AccessionSearchField {
    @dataMember()
    @required()
    public accessionId: number;

    @dataMember()
    @required()
    public accessionNumber: string;

    @dataMember()
    @required()
    public projectNumber: string;
}

export class EmailSearchFieldReadModel {
    @dataMember()
    @required()
    @typedArray(EmailSearchField)
    public searchFields: EmailSearchField[];
}

export class EQueryIdSearchFieldReadModel {
    @dataMember()
    @required()
    @typedArray(EQueryIdSearchField)
    public searchFields: EQueryIdSearchField[];
}

export class AccessionSearchFieldReadModel {
    @dataMember()
    @required()
    @typedArray(AccessionSearchField)
    public searchFields: AccessionSearchField[];
}
